import {
  type InferOutput,
  literal,
  maxLength,
  nonEmpty,
  object,
  picklist,
  pipe,
  regex,
  string,
  trim,
  variant,
} from "valibot";

export const CreateListSchema = object({
  name: pipe(
    string(),
    trim(),
    nonEmpty("List name is required"),
    maxLength(45, "List name can't be more than 45 characters long"),
  ),
});
export type CreateListSchemaType = InferOutput<typeof CreateListSchema>;

const crmSourceIdPipe = pipe(string(), nonEmpty("Source is required"));

// The main identifier (LinkedIn URL variable) is only required for EmailBison.
// It's validated per variant instead of with a forwarded check on the object, so
// it's reported alongside the other field errors rather than after they pass.
export const CrmSourceSchema = variant(
  "sourceType",
  [
    object({
      sourceType: literal("emailbison"),
      sourceId: crmSourceIdPipe,
      mainIdentifier: pipe(
        string(),
        trim(),
        nonEmpty("Variable name is required"),
      ),
    }),
    object({
      sourceType: picklist(["instantly", "smartlead"]),
      sourceId: crmSourceIdPipe,
      mainIdentifier: string(),
    }),
  ],
  "CRM is required",
);
export type CrmSourceSchemaType = InferOutput<typeof CrmSourceSchema>;

export const LinkedInPostSchema = object({
  postUrl: pipe(
    string(),
    regex(
      /^https:\/\/www\.linkedin\.com\/(posts\/[a-zA-Z0-9%_-]+|feed\/update\/urn:li:activity:\d+(\/\S*)?|in\/\S+\/\S+(-\S+)?)(\?.*)?$/,
      "Please enter a valid LinkedIn post URL.",
    ),
  ),
});
